import { api } from "./api";

export const cutomersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCustomers: builder.query({
      query: () => "api/Sales/Customers",
      providesTags: ["customers"],
    }),
    addCustomer: builder.mutation({
      query: (formData) => ({
        url: "api/Sales/Customers",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["customers"],
    }),

    editCustomer: builder.mutation({
      query: (formData) => ({
        url: "api/Sales/Customers",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["customers"],
    }),

    deleteCustomer: builder.mutation({
      query: (customerId) => ({
        url: `api/Sales/Customers?CustomerID=${customerId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["customers"],
    }),
  }),
});

export const {
  useGetCustomersQuery,
  useAddCustomerMutation,
  useEditCustomerMutation,
  useDeleteCustomerMutation,
} = cutomersApi;
